import { render, staticRenderFns } from "./ConfirmAlert.vue?vue&type=template&id=52c8c8b4&scoped=true"
import script from "./ConfirmAlert.vue?vue&type=script&lang=js"
export * from "./ConfirmAlert.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAlert.vue?vue&type=style&index=0&id=52c8c8b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8c8b4",
  null
  
)

export default component.exports